/*
 * pic-nn-web-ui
 *
 * Web UI for neural network applications.
 *
 * @copyright 2020 VSTE CB <http://www.vstecb.cz/>.
 * @license See LICENSE file distributed with this source code for more information.
 */

/**
 * API Endpoint to download a model data as a JSON
 */
export const API_URL_MODEL_SAVE = "https://nn-msp-fpi.prod.vstecb.cz/model-to-json-v1";

/**
 * FPI MSP API URL
 */
export const FPI_MSP_API_URL = "https://nn-msp-fpi.prod.vstecb.cz";
